import { useState } from "react";
import { Dialog } from "./Dialog";

export function ConfirmationDialog({open, setOpen, title, text, onConfirm, onCancel=null}) {

  const closeHandler = () => {
    setOpen(false);
    if (onCancel) onCancel(); 
  }

  const confirmHandler = () => {
    setOpen(false);
    onConfirm();
  }
  
  return (
    <Dialog
      isOpen={open}
      onClose={closeHandler}
      title={title}
    >
      <p className="text-gray-600 mb-6">{text}</p>
      <div className="flex justify-end pt-4 border-t border-gray-200">
        <button
          className="p-4 py-2 text-white bg-indigo-500 hover:bg-indigo-600 rounded-md mr-2 cursor-pointer"
          onClick={confirmHandler}
        >
          <i className="fas fa-check mr-2"></i>Confirm
        </button>
        <button
          className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300 cursor-pointer"
          onClick={closeHandler}
        >
          <i className="fas fa-ban mr-2"></i>Cancel
        </button>
      </div>
    </Dialog>
  );
}